import { render, staticRenderFns } from "./collapse-item.vue?vue&type=template&id=513c4251&scoped=true&"
import script from "./collapse-item.vue?vue&type=script&lang=js&"
export * from "./collapse-item.vue?vue&type=script&lang=js&"
import style0 from "./collapse-item.vue?vue&type=style&index=0&id=513c4251&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c4251",
  null
  
)

export default component.exports